import { Auth } from "@aws-amplify/auth";
import { getCookieByName } from "@/utils/cookies";

let cachedToken: string | null = null;
let cachedExp = 0;
let pendingRefresh: Promise<string> | null = null;
let tokenGeneration = 0;

const REFRESH_BUFFER_MS = 60_000; // refresh 60s before expiry

export const clearAccessToken = () => {
  tokenGeneration += 1;
  cachedToken = null;
  cachedExp = 0;
  pendingRefresh = null;
};

const refreshToken = async (): Promise<string> => {
  const generation = tokenGeneration;
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken();
  const token = accessToken.getJwtToken();

  if (generation !== tokenGeneration) {
    throw new Error("Access token refresh superseded");
  }

  cachedToken = token;
  cachedExp = accessToken.getExpiration() * 1000; // getExpiration() returns seconds
  return token;
};

export const getAccessToken = async (): Promise<string> => {
  const mymAccessToken = getCookieByName("mym_access_token");
  if (mymAccessToken) return mymAccessToken;

  if (cachedToken && Date.now() < cachedExp - REFRESH_BUFFER_MS) {
    return cachedToken;
  }

  if (!pendingRefresh) {
    const refresh = refreshToken().finally(() => {
      if (pendingRefresh === refresh) pendingRefresh = null;
    });
    pendingRefresh = refresh;
  }

  return pendingRefresh;
};
